import { createORPCClient, onError } from "@orpc/client";
import type { ContractRouterClient } from "@orpc/contract";
import type { JsonifiedClient } from "@orpc/openapi-client";
import { OpenAPILink } from "@orpc/openapi-client/fetch";
import contract from "./orpc-contract.ts";

type AccessTokenProvider = string | null | undefined | (() => string | null | undefined);

export interface ORPCClientOptions {
  accessToken?: AccessTokenProvider;
  apiURL?: string | URL;
}

function resolveApiURL(apiURL: ORPCClientOptions["apiURL"]): string {
  const baseURL = globalThis?.location?.origin ?? "http://localhost:3000";
  const resolvedURL = apiURL instanceof URL ? apiURL : new URL(apiURL ?? baseURL, baseURL);

  return resolvedURL.origin;
}

export function createORPCFrontendClient(
  options: ORPCClientOptions = {},
): JsonifiedClient<ContractRouterClient<typeof contract>> {
  const link = new OpenAPILink(contract, {
    headers: () => {
      const accessToken =
        typeof options.accessToken === "function" ? options.accessToken() : options.accessToken;

      if (!accessToken) return {};

      const trimmedAccessToken = accessToken.trim();
      if (trimmedAccessToken.length === 0) return {};

      return { Authorization: `Bearer ${trimmedAccessToken}` };
    },
    interceptors: [onError((error) => console.warn(error))],
    url: resolveApiURL(options.apiURL),
  });

  return createORPCClient(link);
}

export type ORPCClient = ReturnType<typeof createORPCFrontendClient>;
